import React from 'react';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Button from '@material-ui/core/Button';

const UploadDocumentButton = (props) => {
	const {validateDocument, handleSave, disabled, style} = props;
	const hiddenFileInput = React.useRef(null);

	const handleDocumentPickerChange = (event) => handleSave(event.target.files[0]);

	const handleUploadButtonClick = (event) => hiddenFileInput.current.click();

	return (
		<>
			<Button
				disabled={disabled}
				style={style}
				variant='contained'
				color='primary'
				size='small'
				onClick={handleUploadButtonClick}
				startIcon={<CloudUploadIcon />}
			>
				Upload File
			</Button>
			<input type='file' ref={hiddenFileInput} onChange={handleDocumentPickerChange} style={{display: 'none'}}></input>
		</>
	);
};
export default UploadDocumentButton;
